import { RefObject, useEffect, useMemo, useState } from 'react';
import { View } from 'react-vega';
import { Spec } from 'vega';

import { VegaChartSignal } from './vegaChartSignal';

export const useHeightPerEntry = (spec: Spec, vegaViewRef: RefObject<View>) => {
  const [hasDataRecordHeight, initialValue] = useMemo(() => {
    const signal = spec.signals?.find(
      (s) => s.name === VegaChartSignal.dataRecordHeight
    );

    const hasDataRecordHeight = !!signal;
    const initialValue =
      hasDataRecordHeight &&
      'value' in signal &&
      typeof signal.value === 'number'
        ? signal.value
        : 0;

    return [hasDataRecordHeight, initialValue];
  }, [spec]);

  const [heightPerEntry, setHeightPerEntry] = useState(initialValue);

  useEffect(() => {
    const handler = (value: unknown) => {
      if (typeof value === 'number') {
        setHeightPerEntry(value);
      }
    };

    const view = vegaViewRef.current;

    if (hasDataRecordHeight) {
      view?.addSignalListener(VegaChartSignal.dataRecordHeight, handler);
    }

    return () => {
      if (hasDataRecordHeight) {
        view?.removeSignalListener(VegaChartSignal.dataRecordHeight, handler);
      }
    };
  });

  return heightPerEntry;
};
